<template>
    <div class="manager_dashboard">
        <user-menu />
        <div class="wrapper">
            <div class="content-wrapper">
                <div class="container-wrapper center"  style="width: 50%;">
                    <div class="db-card">
                        <flash-message autoHide variant="success"></flash-message>
                        <div class="row justify-content-lg-center justify-content-xl-center">
                            <div class="col-11">
                                <div class="row">
                                    <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                                        <div class="title">{{ firstName + ' ' + lastName }}</div>
                                    </div>
                                    <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                                        <router-link  v-if="isManager" :to="'/manage-mentee-profile/' + menteeId" class="btn btn-primary btn-sm dbViewBtn">Edit</router-link>
                                        <router-link  v-else :to="'/mentor-mentee-profile/' + menteeId" class="btn btn-primary btn-sm dbViewBtn">Edit</router-link>
                                    </div>
                                </div>
                                <hr class="view-mentee-hr"/>
                                <div class="row mentor_row">
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="fa fa-user-circle-o user-icon"></div>
                                        </div>
                                    </div>
                                    <div class="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
                                        <div class="d-flex justify-content-center">
                                            <div class="db-mentor-name">{{ userTypeName }}</div>
                                        </div>
                                        <div class="d-flex justify-content-center">
                                            <div class="db-mentor-name">Mentor: <span>{{ mentorName.join(', ') }}</span></div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row grid_row">
                                    <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                        <div class="label_txt">Email Address: </div>
                                    </div>
                                    <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right">
                                        <div class="label_txt">Phone Number: </div>
                                    </div>
                                    <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6">
                                        <div class="label_val">{{ email }}</div>
                                    </div>
                                    <div class="col-6 col-sm-6 col-md-6 col-lg-6 col-xl-6 text-right">
                                        <div class="label_val">{{ phoneNo }}&nbsp;&nbsp;</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="db-card">
                        <div class="row justify-content-lg-center justify-content-xl-center">
                            <div class="col-11">
                                <div id="dbRecords" class="row">
                                    <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9 ">
                                        <span class="title">Assigned Task Lists</span>&nbsp;&nbsp;&nbsp;
                                    </div>
                                    <div class="col-12" v-if="mappedTaskLists.length > 0">
                                        <div class="db-report-card" v-for="(item, lindex) in mappedTaskLists" :key="lindex">
                                            <div class="row">
                                                <div class="col-9 col-sm-9 col-md-9 col-lg-8 col-xl-9 db_name_block">
                                                    <div class="db-mentee-name">{{item.name}}</div>
                                                    <div class="mt-2">
                                                        <router-link :to="'/mentees-task-goals/' + menteeId + '?e4=' + item.id" class="dbGoalBtn">
                                                            Task Goals
                                                        </router-link>
                                                    </div>
                                                </div>
                                                <div class="col-3 col-sm-3 col-md-3 col-lg-4 col-xl-3">
                                                    <router-link :to="'/mentees-task/'  + menteeId + '?e4=' + item.id" class="btn btn-primary btn-sm dbAddRepsBtn">
                                                    Tasks
                                                    </router-link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 mt-2" v-else>
                                        <div class="db-empty-card">
                                            <h6 class="empty-content-title m-2">No Assigned Task Lists</h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

           <div class="db-card" v-if="isManager">
            <div class="row justify-content-lg-center justify-content-xl-center">
              <div class="col-11">
                <div class="row">
                  <div class="col-6 col-sm-9 col-md-9 col-lg-10 col-xl-9">
                    <div class="title">Documents</div>
                  </div>
                  <div class="col-6 col-sm-3 col-md-3 col-lg-2 col-xl-3 text-right">
                      
                  </div>
                </div>
                <hr class="view-mentee-hr"/> 
                
                <div class="col-12 p-0" v-if="forms.length > 0">
                      <div class="db-report-card" v-for="(form, findex) in forms" :key="findex">
                        <div class="row" >
                          <div class="col-9 col-sm-10 col-md-8 col-lg-9 col-xl-9">
                            <strong>{{ form.name}}</strong>                           

                          </div>
                          <div class="col-3 col-sm-2 col-md-4 col-lg-3 col-xl-3 p-0" style="padding-top: 3px !important;">
                            <div class="col-12" style="text-align: right;">
                            <button type="submit" class="btn btn-primary btn-md start-button dbAddRepsBtn" style="margin-top: 0px;" v-on:click="goToViewForm(form.id)">View Form</button> 
                            </div>
                            
                          </div>
                        </div>
                      </div>    
                    </div>

                     <div class="col-12 mt-2 db-empty-card" v-else>
                            <div class="db-empty-card">
                                <h6 class="empty-content-title">No Documents</h6>
                            </div>
                        </div>

              </div>
            </div>
          </div>


                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import AdminSidebarMenu from '../shared/admin_sidebar_menu.vue';
import { store } from '../../store/store';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});
export default {
    data(){
        return{
            isMenteeAccountStatusModalVisible: false,
            statusType: '',
            tasks_selected: [],
            privileges_selected: [],
            taskLists: [],
            tasklistSelected: [],
            menteeTasklist: [],
            firstName: '',
            lastName: '',
            email: '',
            phoneNo: '',
            status: '',
            countStatusLog: 0,
            compensation: '',
            isManager: false,
            mentorName: [],
            user_roles: [],
            courses: [
            {
                'id': 1,
                'name': 'Mentoring-My Role',
                'checked': true,
            },
            {
                'id': 2,
                'name': 'How to use the system',
                'checked': true,
            },
            ],
            privileges: [
            {
                'id': 1,
                'name': 'can submit reps for review',
                'checked': false,
            },
            ],
            mentorOptions: [],
            mentor_assigned: [],
            assessments: [],
            assessmentSelected: [],
            menteeId: '',
            taskLists: [],
            mappedTaskLists: [],
            program: '',
            userType: '',
            userTypeName: '',
            forms: [],
        }
    },
    computed:{
        getMenteeStatus(){
            if (this.status === true) {
                return 'Mentee - Active';
            } else {
                return 'Mentee - Inactive';
            }
        }
    },
    methods:{
        IsUserManager() {
              var roles = this.$store.state.roles;
              if(roles.indexOf('ROLE_ADMIN') > -1)
              {
                return true;
              }
              else {
                if (this.$store.state.switch_admin_roles && this.$store.state.switch_admin_roles.indexOf("ROLE_ADMIN") > -1) {
                    return true;
                } else {
                    return false;
                }
              }
        },
        goToViewForm(formId) {
         axios.get('/forms-manager/manager/view-form/'+formId + '/'+this.menteeId, {
          })
          .then(response =>  {        
            window.open(process.env.API_ENDPOINT + '/web/forms/' +response.data.filepath, '_blank');                        
          })
          .catch(function(err) {
            console.log("Come here"+ err);
          });
       }
    },
    components: {
        UserMenu,
        GoBack,
        AdminSidebarMenu,
    },
    created() {
        this.menteeId = this.$route.params.mentee_id;
        this.isManager = this.IsUserManager();

        axios.get('/editmentee/alltasklists-account', {
            params: {
                account_id: this.$store.state.user_accountid
            }
        })
        .then(response =>  {
            this.taskLists = response.data; 
            setTimeout(()=>{
            axios.get('/desktop/mentee-details/' + this.menteeId + '/' + this.$store.state.user_accountid, {
        
            })
            .then(response =>  {
            this.firstName = response.data.mentee_first_name;
            this.lastName = response.data.mentee_last_name;
            this.email = response.data.mentee_email;
            this.phoneNo = response.data.mentee_phone_no;
            this.status = response.data.mentee_status;
            this.goals = response.data.mentee_goals;
            this.menteeTasklist = response.data.mentee_tasklist;
            this.compensation = response.data.compensation;
            this.menteeAssessment = response.data.mentee_assessment;
            this.privileges[0].checked = response.data.privileges;
            if (this.privileges[0].checked === true) {
                this.privileges_selected.push(this.privileges[0].id)
            }
            for(var i=0; i < response.data.groups.length; i++) {
                this.mentorName.push(response.data.groups[i].name);
                var group = {value: response.data.groups[i].id, text: response.data.groups[i].groupName};
                this.mentor_assigned.push(group);
            }
            this.countStatusLog = response.data.count_mentee_status_log[1];          
            //console.log(this.countStatusLog);
                for( i=0; i<this.taskLists.length; i++) {
                    if(this.menteeTasklist.indexOf(this.taskLists[i].id) > -1) {
                        var taskItem = {
                        'id': this.taskLists[i].id,
                        'name': this.taskLists[i].name,
                        };
                        this.mappedTaskLists.push(taskItem);
                    }
                }
                console.log(this.taskLists);
            })
            .catch(function(error) {
            console.log(error);
            });
            }, 1500);
        })
        .catch(function(error) {
          console.log(error);
        });

        axios('/desktop/user-account-info/'+this.menteeId+'/'+this.$store.state.user_accountid,
        {
        method: 'GET',
        })
        .then(response => {
            this.program = response.data.program;
            this.userType = response.data.user_type;
            
            if (this.userType == "apprentice") {
                this.userTypeName = "Apprentice";
            } else {
                this.userTypeName = "Mentee";
            }
        })
        .catch(() => {
        });

        if(this.isManager) {
            axios.get('/desktop/mentee/submitted-form-lists/'+this.menteeId + '/' + this.$store.state.user_accountid, {
            })
            .then(response =>  {
                this.forms = response.data;
            })
            .catch(function() {
                
            });
        }

    },
    mounted() {

        axios('/accountgroups',
            {
                method: 'GET',
                params: {
                    account_id: this.$store.state.user_accountid,
                }
            },
        )
        .then(response => {
            for(var i=0; i < response.data.length; i++) {
                var group = {value: response.data[i].id, text: response.data[i].groupName};
                this.mentorOptions.push(group);
            }

            //console.log(this.mentorOptions)
        })
        .catch(error => {

        });
    }
}
</script>
<style scoped>
.db-card {
  color: #002F42;
  background-color: #FFF;
  width: 100%;
  min-height: 120px;
  padding: 10px;
  margin: 10px 0;
  border-radius: 10px;  
}
.db-card .db-mentee-name {
  font-weight: 600;
  word-break: break-word;
}
.db-card .db-mentor-name {
  word-break: break-word;
  font-weight: 900;
}
.db-card .db-mentor-name span{
  word-break: break-word;
  font-weight: normal;
}
.grid_row {
  margin-top: 10px;
}
/* .grid_row .cols { padding: 0; } */
.db-card .label_txt {
  font-weight: 900;
  margin-bottom: 5px;
}
.saveBtn, .saveBtn:active, .saveBtn:focus {
  color: #FFF; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 10px;
  font-weight: 900;
  width: 120px;  
}
.container {
    max-width: 990px;
}
.dbViewBtn{
  color: #29A3E4;
  background: none;
  border: 0px solid #29A3E4;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 5px 0px 0px 5px;
  line-height: 8px;
  width: 32px;
  text-decoration: underline !important;
  float: right;
}
.dbViewBtn:focus, .dbViewBtn:active, .dbViewBtn:hover {
  color: #29A3E4 !important;
  background: none !important;
  border: 0px solid #29A3E4 !important;
  box-shadow: none !important;
} 
.user-icon{ font-size: 60px;  margin-bottom: 10px; }
.mentor_row { margin: 30px; }
.db-card .title{
  font-size: 15px;
  font-weight: 900;
  text-transform: capitalize;
}
.db-card .db-report-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  margin: 10px 0;
}
.db-card .db-empty-card {
  background-color: #e8e8e8;
  border-radius: 5px;
  min-height: 40px;
  padding: 10px;
  text-align: center;
}
.dbAddRepsBtn {
  color: #FFF;
  background-color: #29A3E4;
  border: 1px solid #29A3E4;
  border-radius: 10px;
  font-size: 13px;
  font-weight: 900;
  padding: 10px;
  line-height: 10px;
  width: 100%;
  margin-top: 10px;
}
.btn-primary.dbAddRepsBtn:hover,
.dbAddRepsBtn:active, .dbAddRepsBtn:focus {
  color: #FFF !important;
  background-color: #29A3E4 !important;
  border: 1px solid #29A3E4 !important;
}
.dbGoalBtn {
  text-decoration: underline;
  color: #29A3E4 !important;
}
.db-card .empty-content-title{
  font-size: 13px;
  font-weight: 600;
  text-align: center;
}
.view-mentee-hr {
    margin-top: 5px;
    border: 1px solid #e8e8e8;
}
/* Small Devices */
@media (min-width: 320px) and (max-width: 991px) { 
    .statusBtn, .statusBtn:active, .statusBtn:focus {
        width: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/manager/view_mentee_profile.vue